// extracted by mini-css-extract-plugin
export var advancedProductGroup = "style-mod--advanced-product-group--a3726";
export var badge = "style-mod--badge--00f44";
export var helpIcon = "style-mod--help-icon--9a977";
export var multipleCategories = "style-mod--multiple-categories--6ce90";
export var openedMenu = "style-mod--opened-menu--05d84";
export var parentGroup = "style-mod--parent-group--a50de";
export var productDescription = "style-mod--product-description--8f5b3";
export var selected = "style-mod--selected--42379";
export var selectedCat = "style-mod--selected-cat--33bca";
export var twoVariantsRow = "style-mod--two-variants-row--c42f2";
export var variantsInOneLine = "style-mod--variants-in-one-line--8cc5d";